import { api, ReactQueryOptions } from '@api';

type optionsType = ReactQueryOptions['QuizManager']['create']

export const useCreateQuiz = (options?: optionsType) => (
	api.QuizManager.create.useMutation({
		...options,
		mutationKey: ['QuizManager.create'],
	})
)